import * as React from "react";
import { Archive, Eye, Heart, UserRound } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const pillars = [{
  title: "Deine Figur",
  description: "Möchtest Du Deine Silhouette straffen oder abnehmen? Wir unterstützen Dich mit modernster Technologie auf Deinem Weg zu Deinem Wunschkörper.",
  icon: UserRound,
  link: "/bewei-body"
}, {
  title: "Dein Wohlbefinden",
  description: "Steigere Deine Vitalität und finde Dein inneres Gleichgewicht durch unsere ganzheitlichen Beauty- und Wellness-Konzepte für Körper und Geist.",
  icon: Heart,
  link: "/emp-chair"
}, {
  title: "Dein Aussehen",
  description: "Erlebe ein strahlendes Hautbild und eine vitale Ausstrahlung. Gönne Dir die exklusive Pflege, die Deine natürliche Schönheit zum Leuchten bringt.",
  icon: Eye,
  link: "/bewei-face"
}];
export default function PilaresAcademicos() {
  return <section data-section-id="223052" id="was-ist-dein-ziel" className="bg-background text-foreground py-20 px-4 md:px-8 lg:px-12">
      <div className="mx-auto max-w-screen-xl">
        <h2 className="font-default mb-12 text-center text-3xl tracking-tight !font-semibold md:text-4xl lg:text-5xl">
          DEINE ZIELE
        </h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {pillars.map((pillar, i) => <Card key={i} data-index={i} className="border-border bg-card text-card-foreground hover:-translate-y-2 hover:shadow-xl rounded-3xl border shadow-sm transition-all duration-500 hover:bg-gradient-to-br hover:from-accent/40 hover:to-background">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex">
                  <pillar.icon className="text-primary h-12 w-12 stroke-[1.2] transition-transform duration-500 group-hover:scale-110" />
                </div>
                <CardTitle className="font-default text-foreground text-2xl font-bold">
                  {pillar.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pb-6">
                <CardDescription className="font-default text-muted-foreground text-base leading-relaxed">
                  {pillar.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="ghost" asChild className="text-primary hover:bg-accent/20 hover:text-primary rounded-lg px-4 py-2 font-medium transition-colors">
                  <Link to={pillar.link}>Mehr erfahren</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}